import { Component, OnInit } from "@angular/core";
import { StorageKeys } from "@core";

@Component({
  selector: "app-country-setup",
  templateUrl: "./country-setup.component.html",
  styleUrls: ["./country-setup.component.less"],
  standalone: false,
})
export class CountrySetupComponent implements OnInit {
  countries: any[] = [];
  examCountrySetupModal: boolean = false;
  private user: any = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!);

  ngOnInit(): void {
    this.loadCountries();
  }

  loadCountries() {
    this.countries =
      JSON.parse(localStorage.getItem(StorageKeys.COUNTRY_PROFILES)!) || [];
  }

  isActive(country: any): boolean {
    const wallets: any[] = this.user?.wallet || [];
    return (
      this.user?.exam_country_profile_id === country?.id ||
      wallets.some((w: any) => w?.exam_country_profile_id === country?.id)
    );
  }

  openCountrySetup() {
    this.examCountrySetupModal = true;
  }

  closeCountrySetup() {
    this.examCountrySetupModal = false;
    // Refresh from storage in case a new country was just set up.
    this.user = JSON.parse(localStorage.getItem(StorageKeys.TOKEN)!);
    this.loadCountries();
  }
}
